import { render, staticRenderFns } from "./navDocument4.vue?vue&type=template&id=b21a6a94&scoped=true&"
import script from "./navDocument4.vue?vue&type=script&lang=js&"
export * from "./navDocument4.vue?vue&type=script&lang=js&"
import style0 from "./navDocument4.vue?vue&type=style&index=0&id=b21a6a94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21a6a94",
  null
  
)

export default component.exports